<template>
  <div class="mun-wrap">
    <div class="textarea-wrap">
      <div class="top-wrap" v-if="!onlyShow">
        <span class="margin18">插入:</span>
        <el-popover placement="top-start" width="600" popper-class="my-pop el-popover-index" trigger="click">
          <div>
            <button v-for="(item, index) in emojiList" :key="index" class="emoji" @click.stop="insertHtmlAtCaret(item)">
              {{ item }}
            </button>
          </div>
          <span slot="reference" class="margin18 set-color">表情</span>
        </el-popover>

        <span v-if="myType == 1 || myType == 2" class="margin18 set-color"
          @click.stop="insertHtmlAtCaret('{cusName}')">客户昵称</span>
        <span v-if="myType == 1 || myType == 2 || myType == 3" class="margin18 set-color"
          @click.stop="insertHtmlAtCaret('{empName}')">员工姓名</span>
        <span v-if="myType == 4" class="margin18 set-color" @click.stop="addWelcomeHandle">欢迎语模板</span>
      </div>
      <el-input :disabled="onlyShow" type="textarea" :id="'myTextarea' + myType" ref="myTextarea" clearable
        v-model="content" autocomplete="off" :placeholder="placeholder" @focus="focusHandler"
        @click.native="focusHandler" @keydown.up.down.left.right.native="focusHandler" @blur="inputBlur"
        @select.native="selectHandler" @input.native="onInput($event)" size="small" :maxlength="myType == 6 ? 500 : 200"
        show-word-limit></el-input>
    </div>
    <div class="upload-wrap">
      <div class="btn-wrap" v-if="!onlyShow">
        <el-upload ref="uploadPhotoItem" class="upload-demo" :action="sendUrl" :headers="headers" :data="sendParams"
          :show-file-list="false" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PBG," :before-upload="beforeUploadPhoto"
          :limit="9" :multiple="true" :on-exceed="exceed" :on-success="handleSuccess" :on-error="onError"
          :disabled="handleBtnStatus('img')">
          <!-- <el-button v-if="myType==6" size="small" icon="el-icon-plus" slot="trigger" type="primary" plain :disabled="!(photoList.length == 0 && videoList.length == 0 && linkList.length == 0)">添加图片</el-button> -->

          <el-button size="small" title="图片大小不超过2M，格式为.jpg、.png" icon="el-icon-plus" slot="trigger" type="primary" plain
            :disabled="handleBtnStatus('img')">添加图片</el-button>
        </el-upload>

        <el-button size="small" icon="el-icon-plus" slot="trigger" class="upload-demo" type="primary" v-if="myType != 5"
          plain :disabled="handleBtnStatus('link')" @click="showNewLink">插入链接</el-button>
        <el-button size="small" icon="el-icon-plus" slot="trigger" class="upload-demo" type="primary"
          v-if="myType != 4 && myType != 6" plain :disabled="handleBtnStatus('product')" @click="showProduct">{{
            currentSysm != 2 && currentSysm != 3 ? "插入商品/券" : "插入商品"
          }}</el-button>
        <el-upload v-if="myType == 7" ref="uploadVideoItem" class="upload-demo" :action="sendUrl" :headers="headers"
          :data="sendParams" :show-file-list="false" accept=".MP4,.mp4" :limit="1" :on-exceed="exceed2"
          :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess" :on-error="onError"
          :disabled="handleBtnStatus('video')">
          <el-button size="small" title="视频大小不超过10M，格式为.mp4" icon="el-icon-plus" slot="trigger" type="primary" plain
            :disabled="handleBtnStatus('video')">添加视频</el-button>
        </el-upload>

        <el-upload v-if="myType == 7" ref="uploadFileItem" class="upload-demo" :action="sendUrl" :headers="headers"
          :data="sendParams" :show-file-list="false" accept=".doc,.xlsx,.xls,.ppt,.pdf" :limit="1" :on-exceed="exceed3"
          :before-upload="beforeUploadFile" :on-success="handleFileSuccess" :on-error="onError"
          :disabled="handleBtnStatus('file')">
          <el-button title="文档大小不超过10M，格式为.doc、.xlsx、.xls、.ppt、.pdf" size="small" icon="el-icon-plus" slot="trigger"
            type="primary" plain :disabled="handleBtnStatus('file')">上传文档</el-button>
        </el-upload>

        <el-button size="small" icon="el-icon-plus" slot="trigger" class="upload-demo" type="primary" plain
          v-if="myType == 5" @click="openMaterialDialog">从素材库选取</el-button>

        <!-- <el-button size="small" icon="el-icon-plus" slot="trigger" class="upload-demo" type="primary" plain v-if="myType==6" @click="openMaterialDialog" >上传文档</el-button> -->

        <el-button size="small" icon="el-icon-plus" slot="trigger" class="upload-demo" type="primary" plain
          v-if="myType == 6 || myType == 7" @click="openMaterialDialog" :disabled="!(
            photoList.length == 0 &&
            videoList.length == 0 &&
            linkList.length == 0 &&
            uploadFileList.length == 0&&
            appletList.length == 0
          )
            ">从素材库选取</el-button>
        <!-- <span class="up-tip"
          >提示：点击以上按钮选择素材，只能选择其中某一种类型</span
        > -->

        <el-button v-if="showApplet" size="small" icon="el-icon-plus" slot="trigger" class="upload-demo" type="primary" plain
          :disabled="handleBtnStatus('applet')" @click="openAppletPopup">小程序页面</el-button>

      </div>
      <span v-if="!onlyShow"
        style="color: #9f9fb8; display: block;margin-top: 6px;margin-bottom: 10px;">温馨提示：点击以上按钮选择素材，只能选择其中某一种类型</span>
      <!-- 图片列表 -->
      <div class="upload-photo-wrap" v-show="photoList.length != 0">
        <!--  -->
        <div class="photo-item" v-for="(item, index) in photoList" :key="index">
          <div class="photo-wrap">
            <el-image @click="previewImage(item.fileFullUrl)" class="photo" :src="item.fileFullUrl" fit="contain">
              <!--   src="http://36.137.14.25:9090/wecom/wpHiy3CAAAJEpISih4OQ4Pw95UHKo8sg/2022/10/21/966b55be-c02b-42e7-99aa-37837b5a01d0.jpg"-->
            </el-image>
            <div v-if="!onlyShow" class="close-wrap" @click="deletePhoto('photo', index)">
              <span class="el-icon-close close-icon"></span>
            </div>
          </div>
          <span class="photo-name">{{ item.name }}</span>
        </div>
      </div>
      <!-- 视频  -->
      <div class="upload-video-wrap" v-show="videoList.length != 0">
        <video width="100%" v-show="false" controls="controls" crossOrigin="Anonymous" id="upvideo"
          :key="menuKey"></video>
        <div class="item-wrap" v-if="videoList.length != 0">
          <div class="item-left" @click="videoShow = true">
            <el-image style="height: 100%;width: 100%;" v-if="imgsrc" class="photo" :src="imgsrc"> </el-image>
            <span class="start-wrap">
              <el-image class="start-icon" :src="defaulVideoUrl">
              </el-image>
            </span>
          </div>
          <div class="item-right">
            <div class="video-name">{{ videoList[0].name }}</div>
          </div>
          <div v-if="!onlyShow" class="close-wrap" @click="deletePhoto('video', 0)">
            <span class="el-icon-close close-icon"></span>
          </div>
        </div>
      </div>
      <!-- 文档 -->
      <div class="upload-file" v-show="uploadFileList.length != 0">
        <div class="file-img" v-if="uploadFileList && uploadFileList[0] &&
          uploadFileList[0].resourceType">
          <el-image class="start-icon" :src="handleUrl(uploadFileList[0].resourceType)">
          </el-image>
        </div>
        <i v-else class="el-icon-document-remove"></i>
        <span>{{
          uploadFileList.length > 0 ? uploadFileList[0].name : ""
        }}</span>
        <div v-if="!onlyShow" class="point" @click="deletePhoto('file', 0)">
          <i class="el-icon-delete"></i>
        </div>
      </div>
      <!-- 小程序 -->
      <div class="applet-wrap" v-if="appletList.length != 0">
        <div class="applet-item" v-for="(itemA, indexA) in appletList" :key="indexA">
          <div class="item-left">
            <img class="img" src="@/assets/img/applet.png" alt="" />
          </div>
          <div class="item-right">
            <div class="title">{{ itemA.name }}</div>
            <div class="content">
              {{ itemA.minUrl }}
            </div>
          </div>
          <div v-if="!onlyShow" class="close-wrap" @click="deletePhoto('applet', indexA)">
            <span class="el-icon-close close-icon"></span>
          </div>
        </div>
      </div>
      <!-- 链接 -->
      <div class="link-wrap" v-if="linkList.length != 0">
        <div class="link-item">
          <div class="item-left">
            <div class="title">{{ myFormLink.title }}</div>
            <div class="content" v-if="myType != 3">
              {{ myFormLink.content }}
            </div>
          </div>
          <div class="item-right">
            <el-image v-if="myFormLink.pictureUrl" @click="previewImage(myFormLink.fileFullUrl)" class="photo"
              :src="myFormLink.fileFullUrl">
            </el-image>
          </div>
          <div v-if="!onlyShow" class="close-wrap" @click="deletePhoto('link', 0)">
            <span class="el-icon-close close-icon"></span>
          </div>
        </div>
      </div>
      <!--商品/券 -->
      <div class="link-wrap" v-if="productList.length != 0">
        <div class="link-item">
          <div class="item-left">
            <div class="title">{{ productDetail.title }}</div>
            <div class="content">
              <span v-show="productDetail.linkType == 'goods'">商城价:￥{{ productDetail.price }}</span>
              <span v-show="productDetail.linkType == 'coupon'">满{{ productDetail.couEnableprice }}减{{
                productDetail.price
              }}</span>
            </div>
          </div>
          <div class="item-right">
            <el-image v-if="productDetail.linkType == 'goods'" @click="previewImage(productDetail.pictureUrl)"
              class="photo" :src="productDetail.pictureUrl">
            </el-image>
            <el-image v-else class="photo" :src="require('@/assets/img/ticket.jpg')"
              @click="previewImage(require('@/assets/img/ticket.jpg'))"></el-image>
          </div>
          <div v-if="!onlyShow" class="close-wrap" @click="deletePhoto('product', 0)">
            <span class="el-icon-close close-icon"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频预览 -->
    <el-dialog class="video-dialog" :visible.sync="videoShow" width="400px" style="margin-top:0vh;" close-on-click-modal
      append-to-body>
      <video width="100%" height="auto" v-if="videoList.length != 0" controls="controls">
        <source :src="videoList[0].fileFullUrl" type="video/mp4" />
      </video>
    </el-dialog>
    <el-image class="my-preview-image" :src="previewUrl" ref="myImg" :preview-src-list="previewSrcList">
    </el-image>
    <!-- 用画布截取视频的第一帧作为封面 -->
    <canvas id="mycanvas" style="display: none"></canvas>
    <NewLink ref="newLink" @comfirm="linkComfirm"></NewLink>
    <appletPopup ref="appletPopupRef" v-if="showAppletPopup" @comfirm="appletComfirm" @close="closeApp"></appletPopup>
    <!-- 素材库选择弹层 -->
    <SelectMaterialDialog ref="selectMaterialDialog" :myType="myType" @confirmSelectMateria="confirmSelectMateria"
      @previewTableImage="previewImage"></SelectMaterialDialog>
    <WelcomeTempDia :welcomeDislogVisible="welcomeDislogVisible" @welcomeCloseHandle="welcomeCloseHandle"
      @welcomeConfirmHandle="welcomeConfirmHandle"></WelcomeTempDia>
    <!-- 商品/券弹层 -->
    <ProductVoucher :currentSysm="currentSysm" ref="product" @handleSubmit="getProductDetail" />
  </div>
</template>
<script>
import { biaoqingArr } from "@/utils/emojiData.js";
import ProductVoucher from "@/components/productVoucher.vue";
import NewLink from "@/views/mass/SOP/components/newLink.vue";
import appletPopup from "@/views/mass/SOP/components/appletPopup.vue";
import WelcomeTempDia from "@/views/code/createCode/WelcomeDia.vue";
import SelectMaterialDialog from "@/views/mass/components/selectMaterialDialog.vue";
import { getCheckSystemApi } from "@/api/index.js";
export default {
  name: "myUpload",
  components: {
    NewLink,
    appletPopup,
    WelcomeTempDia,
    SelectMaterialDialog,
    ProductVoucher,
  },
  props: {
    // myType 为1时 新增好友sop，为2时生日提醒sop，为3时新增朋友圈sop,4为活码，5为群发  6话术库 7群sop
    myType: {
      type: Number,
      default: 1,
    },
    /**仅仅展示使用 即不能编辑 */
    onlyShow: {
      type: Boolean,
      default: false,
    },
    /**展示小程序页面  默认true */
    showApplet: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "在这里编辑文字内容",
    },
    upLoadData: {
      type: Object,
      default: () => ({
        content: '',
        resourceVos: [],
        sopLink: []
      })
    }
  },
  data() {
    return {
      defaulVideoUrl: require('@/assets/chatLog/video.png'),
      xlsxDefaulUrl: require('@/assets/chatLog/excel.png'),
      pdfDefaulUrl: require('@/assets/chatLog/pdf.png'),
      pptDefaulUrl: require('@/assets/chatLog/ppt.png'),
      docDefaulUrl: require('@/assets/chatLog/word.png'),
      loading: null,
      videoShow: false,
      previewUrl: "",
      previewSrcList: [],
      emojiListShow: false,
      emojiList: biaoqingArr,
      content: "",
      type: 0, // 类型 0 图片，1视频，2链接
      menuKey: 1,
      photoList: [], // 上传的图片数组
      videoList: [],
      myFormLink: {
        title: "",
        httpUrl: "",
        content: "",
        pictureUrl: "",
        pictureName: "",
        fileFullUrl: "",
      },
      productDetail: {
        title: "",
        pictureUrl: "",
        price: "0.00",
      },
      productList: [],
      imgsrc: "", // 视频封面
      linkList: [], // 链接列表
      resourceVos: [], // 提交给父组件的数组
      appletVo: [],
      headers: {
        authorization: "",
      },
      sendParams: {
        scene: this.myType == 3 ? "friMomentSOP" : "",
      },
      inputFocus: null,
      sendUrl: this.$baseUrl + "/api/chatMaterial/uploadFile",
      myContent: "",
      welcomeDislogVisible: false,
      needLoadingRequestCount: 0,
      uploadFileList: [],
      /**小程序链接数据 */
      appletList: [],
      /** 当前系统 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
      currentSysm: 0,
      showAppletPopup: false,
    };
  },

  computed: {},
  methods: {
    handleUrl(type) {
      let res = this[`${type}DefaulUrl`]
      switch (type) {
        case 'xls':
          res = this.xlsxDefaulUrl
          break;

        default:
          break;
      }
      return res
    },
    /**处理按钮显示隐藏  禁用  目前只能选择一种 */
    handleBtnStatus(type) {
      // 照片
      const imgM = this.photoList && this.photoList.length ? this.photoList.length : 0
      // 链接
      const linkM = this.linkList && this.linkList.length ? this.linkList.length : 0
      // 商品、券
      const productM = this.productList && this.productList.length ? this.productList.length : 0
      // 视频
      const videoM = this.videoList && this.videoList.length ? this.videoList.length : 0
      // 文档
      const fileM = this.uploadFileList && this.uploadFileList.length ? this.uploadFileList.length : 0
      // 小程序
      const appletM = this.appletList && this.appletList.length ? this.appletList.length : 0
      /**是否全部都是空 */
      const allM = !imgM && !linkM && !productM && !videoM && !fileM && !appletM ? true : false
      /**是否有类型已选 */
      let hasBtn = ''
      if (!allM) {
        if (imgM) {
          hasBtn = 'img'
        } else if (linkM) {
          hasBtn = 'link'
        } else if (productM) {
          hasBtn = 'product'
        } else if (videoM) {
          hasBtn = 'video'
        } else if (fileM) {
          hasBtn = 'file'
        } else if (appletM) {
          hasBtn = 'applet'
        }
      }
      //             console.log(`handleBtnStatus-----${type}`, `照片：${imgM}；
      //   链接：${linkM}；商品、券：${productM}；
      // 视频：${videoM}；文档：${fileM}；是否全部都是空：${allM}；是否有类型已选：${hasBtn}；`

      //             );
      let res = false
      switch (type) {
        case 'img':
          hasBtn != 'img' ? res = true : ''
          // 最多九张照片
          if (imgM >= 9) {
            res = true
          }
          break;
        case 'link':
          hasBtn != 'link' ? res = true : ''
          break;
        case 'product':
          hasBtn != 'product' ? res = true : ''
          // 最多一个商品或者一个券
          if (productM >= 1) {
            res = true
          }
          break;
        case 'video':
          hasBtn != 'video' ? res = true : ''
          // 最多一个视频
          if (videoM >= 1) {
            res = true
          }
          break;
        case 'file':
          hasBtn != 'file' ? res = true : ''
          // 最多一个文档
          if (fileM >= 1) {
            res = true
          }
          break;
        case 'applet':
          hasBtn != 'applet' ? res = true : ''
          // 最多一个小程序链接
          if (appletM >= 1) {
            res = true
          }
          break;

        default:
          break;
      }
      // 所有类型没选 即初始化时候
      if (allM) {
        res = false
      }
      return res
    },

    // 获取商品/券
    getProductDetail(row) {
      // console.log(row.linkUrl);
      // console.log(row.linkUrl.replaceAll('=', ':'))
      // return;
      this.productDetail = {
        pictureUrl: row.pictureUrl,
        price: row.price,
        title: row.title,
        linkType: row.linkType,
        couEnableprice: row.couEnableprice,
        httpUrl: row.linkUrl ? row.linkUrl.replaceAll("=", ":") : "",
      };
      this.productList.push(this.productDetail);
      this.submitTO(true);
      // console.log(this.productList)
      // console.log(row)
    },
    initParams() {
      this.content = "";
      this.photoList = [];
      this.videoList = [];
      this.linkList = [];
      this.appletList = [];
      this.productList = [];
      this.myFormLink = {
        title: "",
        httpUrl: "",
        content: "",
        pictureUrl: "",
        pictureName: "",
        fileFullUrl: "",
      };
      this.productDetail = {
        title: "",
        price: "0.00",
        pictureUrl: "",
      };
      // setTimeout(()=>{
      // console.log(this.$refs.uploadPhotoItem.uploadFiles)
      // if (this.myType != 5) this.$refs.uploadVideoItem.uploadFiles = [];
      // }, 2000)
      this.$nextTick(() => {
        this.$refs.uploadPhotoItem ? this.$refs.uploadPhotoItem.uploadFiles = [] : ''
      });
    },
    //选择欢迎语模板
    addWelcomeHandle() {
      this.welcomeDislogVisible = true;
    },
    //关闭欢迎语模板回调
    welcomeCloseHandle() {
      this.welcomeDislogVisible = false;
    },
    //选择欢迎语模板 确定回调
    welcomeConfirmHandle(val) {
      if (!!val) {
        // this.content = val.welcomeContent
        this.insertHtmlAtCaret(val.welcomeContent);
      }
      // this.submitTO()
      this.welcomeDislogVisible = false;
    },
    // 打开素材库弹窗
    openMaterialDialog() {
      this.$refs.selectMaterialDialog.open();
    },
    // 选择素材弹框的确认事件
    confirmSelectMateria(selectItem) {
      console.log('7897897,', this.upLoadData, this.content);
      // {{ upLoadData }}---{{ content }}
      const showTips = () => {
        this.$confirm("选中的素材将会覆盖原有的内容", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          title: "提示",
          cancelButtonText: "取消",
        })
          .then((res) => {
            handleData()
          })
          .catch((action) => {
            // that.$message("取消删除");
            this.$message({
              message: "取消更换",
              type: "info",
              offset: 30,
              customClass: "info-message",
            });
          });
      }

      const handleData = () => {
        let obj = JSON.parse(JSON.stringify(selectItem));
        console.log("obj", obj);
        this.resourceVos = obj.chatMaterialResources;
        this.content = selectItem.content;
        this.photoList = [];
        this.videoList = [];
        this.linkList = [];
        this.appletList = [];
        this.$refs.uploadPhotoItem.uploadFiles = [];
        // 这里需要判断，那一条数据是哪个类型-然后保存到相对应的数组里面
        this.handleChangeData(selectItem);
        // selectItem.chatMaterialResources.forEach((item) => {
        //   let obj = {
        //     url: item.url,
        //     name: item.fileName,
        //     fileFullUrl: item.fileFullUrl,
        //   };
        //   this.photoList.push(obj);
        //   this.$refs.uploadPhotoItem.uploadFiles.push(obj);
        // });
        this.submitTO();
      }
      if ((this.upLoadData && this.upLoadData.resourceVos && this.upLoadData.resourceVos.length) || this.content) {
        showTips()
      } else {
        handleData()
      }
    },
    // 更改素材库下来的数据  群sop（myType=7）开发视频和文件选中
    handleChangeData(data) {
      console.log("XXXX判断数据是哪一种类型的数据话书库创建话术XXX", data, this.myType);
      if (data.chatMaterialResources.length > 0) {
        data.chatMaterialResources.forEach((item) => {
          if (item.type == "image" || item.type == "img") {
            this.type = 0;
            let obj = {
              url: item.url,
              name: item.fileName,
              fileFullUrl: item.fileFullUrl,
            };

            this.photoList.push(obj);
            this.$refs.uploadPhotoItem.uploadFiles.push(obj);
          } else if (item.type == "mp4") {
            if (this.myType == 7) {
              this.type = 1;
              this.findvideocover(item.fileFullUrl, {
                url: item.url,
                name: item.fileName,
              });
            } else {
              this.content = "";
              this.type = 1;
              this.$message.warning("暂不支持视频素材");
            }
            // 旧的 是text   新的是file
          } else if (item.type == "text" || item.type == "file") {

            // 文档
            if (this.myType == 7) {
              this.type = 'file';
              console.log(5555, item);
              this.uploadFileList.push({
                fileFullUrl: item.fileFullUrl,
                name: item.fileName,
                url: item.url,
                resourceType: item.fileName ? item.fileName.split(".")[1] : ''
              });
            } else {
              this.content = "";
              return this.$message.warning("暂不支持文档类型素材");
            }
          }

          // 上传链接XXX--
        });
      } else if (data.chatMaterialLink) {
        console.log("datadatadatadatadatadata", data);
        if (this.myType !== 6) {
          this.content = "";
          return this.$message.warning("暂不支持链接类型素材");
        }
        console.log("链接xxxxxx", data.chatMaterialLink);
        // data.chatMaterialLink.forEach((item) => {
        this.myFormLink = {
          title: data.chatMaterialLink.content,
          httpUrl: data.chatMaterialLink.httpUrl,
          content: data.chatMaterialLink.remark,
          pictureUrl: data.chatMaterialLink.pictureUrl,
          pictureName: data.chatMaterialLink.pictureName,
          fileFullUrl: data.chatMaterialLink.pictureFullUrl,
        };
        this.linkList.push(this.myFormLink);
        this.$refs.uploadPhotoItem.uploadFiles.push(this.myFormLink);
        // });
      }
    },
    // 保存光标位置
    inputBlur(e) {
      this.inputFocus = e.target.selectionStart;
    },
    // 焦点跳出元素内
    focusHandler(e) {
      setTimeout(() => {
        let selStart = e.target.selectionStart;
        let beforeArrLength = this.content.slice(0, selStart).split("{").length;
        let afterArrLength = this.content.slice(0, selStart).split("}").length;
        //根据'['和']'生成两个数组 判断数组长度 是否相等 不相等就不成对就移动光标
        if (beforeArrLength != afterArrLength) {
          let pos = this.content.indexOf("}", selStart) + 1;
          if (beforeArrLength > afterArrLength && e.code == "ArrowLeft") {
            //按下按键左箭头
            pos = this.content.lastIndexOf("{", selStart);
          }
          this.changeFocus(e.target, pos, pos);
        }
      }, 100);
    },
    // 选择元素剩余部分
    selectHandler(e) {
      // 光标开始位置往前
      for (let i = e.target.selectionStart - 1; i >= 0; i--) {
        if (this.content[i] == "{") {
          this.changeFocus(e.target, i, e.target.selectionEnd);
          break;
        }
        if (this.content[i] == "}") {
          break;
        }
      }
      // 光标结束位置往后
      for (let i = e.target.selectionEnd; i < this.content.length; i++) {
        if (this.content[i] == "}") {
          this.changeFocus(e.target, e.target.selectionStart, i + 1);
          break;
        }
        if (this.content[i] == "{") {
          break;
        }
      }
    },
    onInput(e) {
      if (e.target) {
        this.content = e.target.value;
      }
      // 原生触发
      //deleteContentBackward==退格键 deleteContentForward==del键
      if (
        e.inputType == "deleteContentBackward" ||
        e.inputType == "deleteContentForward"
      ) {
        let beforeIndex = 0;
        let afterIndex = 0;
        // 光标位置往前
        for (let i = e.target.selectionStart - 1; i >= 0; i--) {
          if (this.content[i] == "{") {
            beforeIndex = i;
            afterIndex = e.target.selectionStart;
            break;
          }
          if (this.content[i] == "}") {
            break;
          }
        }
        // 光标位置往后
        for (let i = e.target.selectionStart; i < this.content.length; i++) {
          if (this.content[i] == "}") {
            afterIndex = i + 1;
            beforeIndex = e.target.selectionStart;
            break;
          }
          if (this.content[i] == "{") {
            break;
          }
        }
        if (beforeIndex == 0 && afterIndex == 0) {
          this.submitTO(true);
          return;
        }
        let beforeStr = this.content.slice(0, beforeIndex);
        let afterStr = this.content.slice(afterIndex);
        this.content = beforeStr + afterStr;
        console.log("bbbb", this.content);
        this.inputFocus = beforeStr.length;
        this.$nextTick(() => {
          this.changeFocus(e.target, this.inputFocus, this.inputFocus);
        });
      }
      this.submitTO(true);
    },
    // 修改光标位置
    changeFocus(target, start, end) {
      let range,
        el = target;
      if (el.setSelectionRange) {
        el.setSelectionRange(start, end);
      } else {
        range = el.createTextRange();
        range.collapse(false);
        range.select();
      }
    },
    // 提交数据给父组件 flag为true时是输入框调用，此时不更新资源数组resourceVos
    submitTO(flag) {
      if (!flag) {
        console.log("XXXXXXXXXXXthis.type", this.type);
        this.resourceVos = [];
        if (this.type == 0) {
          this.photoList.forEach((item) => {
            let vosObj = {
              resourceName: item.name, // 文件名
              url: item.url || item.fileFullUrl, // 文件路径
              resourceType: "image", // 文件类型 图片：image,视频：video
            };
            this.resourceVos.push(vosObj);
          });
        } else if (this.type == 1) {
          console.log("this.videoList", this.videoList);
          this.videoList.forEach((item) => {
            let vosObj = {
              resourceName: item.name, // 文件名
              url: item.url, // 文件路径
              resourceType: "video", // 文件类型 图片：image,视频：video
            };
            this.resourceVos.push(vosObj);
          });
        } else if (this.type == 'file') {
          this.uploadFileList.forEach((item) => {
            let vosObj = {
              resourceName: item.name, // 文件名
              url: item.url, // 文件路径
              resourceType: item.url.split(".")[1], // 文件类型 图片：image,视频：video
            };
            console.log("数据结构XXXX", vosObj);
            this.resourceVos.push(vosObj);
          });
        } else if (this.type == 'applet') {
          console.log("小程序XXXX-------", this.appletList);
          // 小程序
          this.appletList.forEach((item) => {
            this.appletVo = []
            let vosObjApp = {
              appId: item?.msgMinAppId||null,//appId
              name: item.name,//名称
              pageType: item.pageType,//小程序页面类型 0 常用页面 1 自定义页面
              url: item.minUrl, // 文件路径
            };
            console.log("小程序XXXX", vosObjApp);
            this.appletVo.push(vosObjApp);
          });
        }
      } else if (this.type == 0) {
        // 输入文字等轻量更新时按当前photoList重建图片资源；列表为空要清空，否则残留上一条的素材
        this.resourceVos = [];
        this.photoList.forEach((item) => {
          let vosObj = {
            resourceName: item.name, // 文件名
            url: item.url || item.fileFullUrl, // 文件路径
            resourceType: "image", // 文件类型 图片：image,视频：video
          };
          this.resourceVos.push(vosObj);
        });
      }
      let myUploadFlag = false;
      if (
        this.content ||
        this.photoList.length > 0 ||
        this.videoList.length > 0 ||
        this.linkList.length > 0 ||
        this.productList.length > 0 ||
        this.resourceVos.length > 0
      ) {
        myUploadFlag = true;
      }
      console.log("111111this.content", this.content);
      console.log("this.resourceVos", this.resourceVos);
      let obj = {
        flag: myUploadFlag,
        content: this.content,
        linkVo: this.linkList.length == 0 ? null : this.myFormLink,
        resourceVos: this.resourceVos,
        product: this.productList.length == 0 ? null : this.productDetail,
        appletVo: this.appletVo.length == 0 ? null : this.appletVo[0],
      };
      console.log("obj++++++", obj);
      this.$emit("receiveParam", obj);
    },
    selectStaff() {
      this.dialogVisibleTree = true;
    },
    async insertHtmlAtCaret(value) {
      console.log("value", value);
      const myField = document.querySelector("#myTextarea" + this.myType);
      if (myField.selectionStart || myField.selectionStart === 0) {
        let startPos = myField.selectionStart;
        let endPos = myField.selectionEnd;
        this.content =
          myField.value.substring(0, startPos) +
          value +
          myField.value.substring(endPos, myField.value.length);
        await this.$nextTick();
        myField.focus();
        myField.setSelectionRange(endPos + value.length, endPos + value.length);
      } else {
        this.content = value;
      }
      this.onInput(this.content);
    },
    // 删除
    deletePhoto(type, index) {
      this.$confirm("您确定删除该素材？提交后将无法撤回？", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        title: "删除",
        cancelButtonText: "取消",
      })
        .then((res) => {
          console.log("typeXXXXX0", type);
          if (type == "photo") {
            console.log("typeXXXXX1", type);
            this.photoList.splice(index, 1);
            this.$refs.uploadPhotoItem.uploadFiles.splice(index, 1);
          } else if (type == "video") {
            this.videoList.splice(index, 1);
            this.$refs.uploadVideoItem.uploadFiles.splice(index, 1);
            console.log("this.videoList", this.videoList);
          } else if (type == "file") {
            console.log("上传文件XXXXX", this.uploadFileList, this.uploadFiles);
            this.uploadFileList.splice(index, 1);
            this.$refs.uploadFileItem.uploadFiles.splice(index, 1);
          } else if (type == "link") {
            this.linkList.splice(index, 1);
            console.log("this.linkList", this.linkList);
            this.myFormLink = {
              title: "",
              httpUrl: "",
              content: "",
              pictureUrl: "",
              pictureName: "",
              fileFullUrl: "",
            };
            this.$refs.uploadPhotoItem.uploadFiles.splice(index, 1);
          } else if (type == "applet") {
            this.appletList = []
            console.log("applet+++++++", this.appletList);
          } else {
            this.productList.splice(index, 1);
            this.productDetail = {
              title: "",
              pictureUrl: "",
              price: "0.00",
            };
          }
          this.submitTO();
          console.log("typeXXXXX2", type);
        })
        .catch((action) => {
          console.log("XXXXXXXXXXX", action);
          // that.$message("取消删除");
          this.$message({
            message: "取消删除",
            type: "info",
            offset: 30,
            customClass: "info-message",
          });
        });
    },
    handleSuccess(res, file, fileList) {
      console.log("res", res);
      if (res.error.code == 200) {
        this.type = 0;
        this.photoList.push(res.data);
        this.submitTO();
      } else {
        this.$message({
          message: res.error.message,
          type: "error",
          offset: 30,

          duration: 4000,
        });
        // 关闭页面loading
        this.loading.close();
        this.loading = null;
        if (!this.$refs.uploadVideoItem) return;
        this.$refs.uploadVideoItem.uploadFiles.splice(
          this.$refs.uploadVideoItem.uploadFiles.length - 1,
          1
        );
      }
      setTimeout(() => {
        this.hideLoading();
      }, 200);
    },
    // 上传视频成功回调
    handleVideoSuccess(res, file, fileList) {
      this.menuKey++;
      console.log("res", res);
      if (res.error.code == 200) {
        this.type = 1;
        this.findvideocover(res.data.fileFullUrl, res.data);
      } else {
        this.$message({
          message: res.error.message,
          type: "info",
          offset: 30,
          customClass: "info-message",
          duration: 4000,
        });
        this.$refs.uploadVideoItem.uploadFiles = [];
      }
      setTimeout(() => {
        this.hideLoading();
      }, 200);
    },
    showNewLink() {
      this.$refs.newLink.show(this.myFormLink, this.myType);
    },
    showProduct() {
      this.$refs.product.show(this.myFormLink, this.myType);
      this.$refs.product.voucherPageParm.couponName = "";
      this.$refs.product.productPageParm.productName = "";
      this.$refs.product.productPageParm.activeName = "1";
      if (this.currentSysm != 2 && this.currentSysm != 3) {
        this.$refs.product.getVoucherList();
      }

      this.$refs.product.getProductList();
    },
    // 链接新建
    linkComfirm(form) {
      this.linkList = [];
      this.type = 2;
      this.myFormLink = form;
      this.linkList.push(this.myFormLink);
      this.submitTO();
    },
    /**打开选择小程序页面 */
    openAppletPopup() {
      this.showAppletPopup = true
      setTimeout(() => {
        this.$refs.appletPopupRef.show(this.appletList);
      }, 20);
    },
    /**确定新增小程序页面 */
    appletComfirm(val) {
      this.showAppletPopup = false
      console.log('确定新增小程序页面', val);

      this.type = 'applet'
      this.appletList = [val];
      // this.myFormLink = form;
      // this.linkList.push(this.myFormLink);
      this.submitTO();
    },
    /**关闭窗口 */
    closeApp(val) {
      this.showAppletPopup = false
    },
    exceed() {
      setTimeout(() => {
        this.hideLoading();
      }, 200);
      this.$message.error("最多只能上传9张图片");
    },
    exceed2() {
      setTimeout(() => {
        this.hideLoading();
      }, 200);
      this.$message.error("最多只能上传1个视频");
    },
    exceed3(file, filList) {
      console.log("12121", file, filList, this.uploadFileList);
      setTimeout(() => {
        this.hideLoading();
      }, 200);

      this.$message.error("最多只能上传1个文档");
    },
    onError(err) {
      setTimeout(() => {
        this.hideLoading();
      }, 200);
      this.$message.error("上传失败，请重试！");
      console.log("err", err);
    },
    //显示loading
    showLoading() {
      // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
      // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
      if (this.needLoadingRequestCount === 0 && !this.loading) {
        this.loading = this.$loading({
          lock: true,
          text: "拼命上传中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      this.needLoadingRequestCount++;
    },
    //隐藏loading
    hideLoading() {
      // if(this.needLoadingRequestCount <= 0) return
      this.needLoadingRequestCount--;
      if (this.needLoadingRequestCount === 0) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 删除文档数据
    handleDelFile() {
      console.log("到底是谁组织我上传文件了", this.sendParams);
      this.uploadFileList = [];
    },
    // 上传文档之前
    beforeUploadFile(file) {
      console.log('上传文档之前', file);
      const isLt2M = file.size / 1024 / 1024 < 20; // 限制大小
      if (
        [
          "application/msword",
          "application/vnd.ms-excel",
          "application/ppt",
          "application/pdf",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("上传文档的格式只能是 doc、excel、ppt、pdf 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传文档大小不能超过 20MB!");
        return false;
      }
      this.showLoading();
      return true;
    },
    /**上传文档成功的回调 */
    handleFileSuccess(res, val) {
      console.log("上传文档之前XXX", res, val);
      if (res.error.code == 200) {
        this.type = 'file';
        // this.findvideocover(res.data.fileFullUrl,res.data)
        const objM = {
          ...res.data,
          type: 'file',
          resourceType: res.data.url.split(".")[1]
        }

        this.uploadFileList.push(objM);
        this.submitTO();
        console.log("XXXXXX获取相关数据结构", this.uploadFileList);
      } else {
        this.$message({
          message: res.error.message,
          type: "info",
          offset: 30,
          customClass: "info-message",
          duration: 4000,
        });
        this.$refs.uploadVideoItem.uploadFiles = [];
      }
      setTimeout(() => {
        this.hideLoading();
      }, 200);
    },
    // 上传图片之前
    beforeUploadPhoto(file) {
      const isLt2M = file.size / 1024 / 1024 < 2; // 限制图片大小
      if (["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) == -1) {
        this.$message.error("上传图片只能是 JPG 、PNG、JPG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      this.showLoading();
      return true;
    },
    // 上传视频之前
    beforeUploadVideo(file) {
      console.log("ssssfile", file);
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("上传视频只能是 mp4 格式!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传视频大小不能超过 10MB!");
        return false;
      }
      this.showLoading();
      return true;
    },
    //截取视频第一帧作为播放前默认图片
    findvideocover(url, data) {
      let that = this;
      this.$nextTick(() => {
        const video = document.getElementById("upvideo");
        const source = document.createElement("source");
        source.src = url;
        source.type = "video/mp4";
        video.appendChild(source);
        video.currentTime = 1; // 第一帧
        that.videoList = [];
        let obj = {
          fileFullUrl: url,
          imgsrc: "",
          url: data.url,
          name: data.name,
        };
        that.videoList.push(obj);
        video.addEventListener("loadeddata", function () {
          var canvas = document.createElement("canvas");
          canvas.width = 142;
          canvas.height = 142;
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, canvas.width, canvas.height);
          that.imgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
          that.videoList[0].imgsrc = that.imgsrc;
          that.submitTO();
        });
      });
    },
    previewImage(url) {
      this.previewSrcList = [];
      this.previewUrl = url;
      this.previewSrcList.push(url);
      this.$refs.myImg.showViewer = true;
    },
    /** 获取当前系统 */
    getCheckSystem() {
      getCheckSystemApi().then((res) => {
        console.log("res++++", res.error.code == 200);
        if (res && res.error && res.error.code == 200 && res.data) {
          this.currentSysm = res.data.code || null;
        }
      });
    },
  },
  /** 生命周期 */
  created() {
    console.log("没有进来吗？");
    this.headers.authorization = localStorage.getItem("Authorization");
    this.getCheckSystem();
  },
  watch: {
    /**用在编辑回显 */
    upLoadData: {
      handler(newVal, oldVal) {
        console.log('upLoadDatava----watch66', newVal)
        if (newVal) {
          this.initParams()
          this.content = newVal.content ? newVal.content : ''
          if (newVal?.sopLink) {
            console.log('链接预览', newVal.sopLink)
            
            if (newVal.sopLink.linkType && newVal.sopLink.linkType == 'goods') {
              // 商品  后端都是使用sopLink接受的 这里需要转
              this.productDetail = newVal.sopLink
              this.productList.push(newVal.sopLink)
            } else {
              // 链接
              this.myFormLink.title = newVal.sopLink?.title || null
              this.myFormLink.content = newVal.sopLink?.content || null
              this.myFormLink.httpUrl = newVal.sopLink?.httpUrl || null
              this.myFormLink.remark = newVal.sopLink?.content || null
              this.myFormLink.pictureUrl = newVal.sopLink?.pictureUrl || null
              this.myFormLink.pictureName = newVal.sopLink?.pictureName || null
              this.myFormLink.fileFullUrl = newVal.sopLink?.fileFullUrl || null
              this.linkList.push(newVal.sopLink)
            }
          } else if (newVal.resourceVos && newVal.resourceVos.length) {
            console.log('资源预览',newVal.resourceVos);
            if (newVal.resourceVos[0].resourceType == 'image') {
              // 照片
              newVal.resourceVos.forEach(v => {
                this.photoList.push({
                  fileFullUrl: v.resourceUrl,
                  name: v.resourceName,
                  url: v.url
                })
              })
            } else if (newVal.resourceVos[0].resourceType == 'video') {
              // 视频
              newVal.resourceVos[0].fileFullUrl = newVal.resourceVos[0].resourceUrl
              newVal.resourceVos[0].name = newVal.resourceVos[0].resourceName
              this.videoList = newVal.resourceVos
            } else if (newVal.resourceVos[0].resourceType == 'doc'
              || newVal.resourceVos[0].resourceType == 'xlsx' ||
              newVal.resourceVos[0].resourceType == 'xls' ||
              newVal.resourceVos[0].resourceType == 'ppt' ||
              newVal.resourceVos[0].resourceType == 'pdf'
            ) {
              // 文档 
              newVal.resourceVos[0].name = newVal.resourceVos[0].resourceName
              this.uploadFileList = newVal.resourceVos
            } {
              // this.findvideocover(newVal.resourceVos[0].resourceUrl,newVal.resourceVos[0].resourceName)
            }
          } else if (newVal.appletVo) {
            console.log('小程序预览',newVal.appletVo);
            
            this.appletList = [newVal.appletVo]
          }
          this.submitTO(false);
        }
      },
      deep: true,
    }
  },
};
</script>
<style lang="scss" scoped>
.my-pop {
  .emoji {
    display: inline-block;
    padding: 3px;
    border: 1px solid transparent;
    cursor: pointer;
    background: #fff;
    font-size: 16px;

    &:hover {
      background-color: #ddded8;
      border: 1px solid #b3c1fd;
      border-radius: 4px;
    }
  }
}

.video-dialog {
  .el-dialog {
    box-shadow: unset;
    width: 100%;
    background-color: unset;
    margin-top: 7vh !important;

    .el-dialog__headerbtn {
      display: none;
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
      display: flex;
      justify-content: center;
      background-color: transparent;
    }
  }
}
</style>
<style lang="scss" scoped>
/deep/.el-popover {
  z-index: 3000 !important;
}

.upload-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f9f9;
  width: fit-content;
  padding: 10px;
  border-radius: 5px;
  gap: 5px;

  .point {
    width: 15px;
    height: 15px;
    line-height: 15px;
    font-size: 15px;

    &:hover {
      color: #409eff;
      cursor: pointer;
    }
  }

  &:hover {
    .point {
      display: block;
    }
  }

  .file-img {
    width: 40px;
    height: 40px;
  }

  span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

  }
}

.mun-wrap {
  line-height: initial;

  .textarea-wrap {
    border: 1px solid #e6e9eb;
    border-radius: 4px;
    padding: 0;
    margin-bottom: 15px;

    .top-wrap {
      padding: 7px 10px 5px 10px;
      border-bottom: 1px solid #eeeff3;

      .margin18 {
        margin-right: 18px;
      }

      .set-color {
        color: #2684ff;
        cursor: pointer;
      }
    }

    /deep/ .el-textarea__inner {
      min-height: 200px !important;
      padding: 10px;
      border: none;
      resize: none !important;
    }
  }

  .upload-wrap {
    .btn-wrap {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;

      /deep/.el-button {
        margin: 0 !important;
      }

      .upload-demo {
        // margin-right: 10px;

        // &:last-of-type {
        //   margin-right: 13px;
        // }
      }

      .up-tip {
        font-size: 12px;
        color: #959595;
      }

      /deep/ .el-button {
        padding: 6px 10px 6px 8px;
      }

      /deep/ .el-button.is-disabled {
        background: rgba(218, 218, 218, 0.5);
        color: #c0c0c0;
        border-color: rgba(218, 218, 218, 0.5);
      }
    }

    .upload-photo-wrap {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      // margin-top: 45px;
      display: grid;
      grid-template-columns: repeat(3, 80px);
      gap: 20px 50px;

      .photo-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #f9f9f9;
        border-radius: 4px;

        .photo-wrap {
          position: relative;
          height: 80px;
          width: 80px;
          cursor: pointer;

          .photo {
            width: 100%;
            height: 100%;
          }

          .close-wrap {
            position: absolute;
            top: -6px;
            right: -6px;
            border-radius: 50%;
            width: 13px;
            height: 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            cursor: pointer;
            background-color: #ff5e6a;

            .close-icon {
              color: white;
            }
          }
        }

        .photo-name {
          font-size: 14px;
          margin-top: 7px;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }
    }

    .upload-video-wrap {
      display: flex;

      .item-wrap {
        display: flex;
        align-items: center;
        position: relative;

        .item-left {
          width: 71px;
          height: 71px;
          position: relative;

          .photo {
            width: 100%;
            height: 100%;
          }

          .start-wrap {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #f9f9f9;

            .start-icon {
              width: 100%;
              height: 100%;
            }
          }
        }

        .item-right {
          padding-left: 13px;
          width: 190px;
          background: #f9f9f9;
          height: 100%;
          display: flex;
          align-items: center;

          .video-name {
            font-size: 14px;
            color: #666666;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
        }

        .close-wrap {
          position: absolute;
          top: -6px;
          right: -6px;
          border-radius: 50%;
          width: 13px;
          height: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          background-color: #ff5e6a;

          .close-icon {
            color: white;
          }
        }
      }
    }

    .link-wrap {
      display: flex;

      .link-item {
        background: #f9f9f9;
        padding: 9px 9px 9px 11px;
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 4px;

        .item-left {
          width: 163px;
          margin-right: 26px;

          .title {
            font-weight: 600;
            font-size: 14px;
            letter-spacing: -0.01px;
            color: #666666;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .content {
            font-weight: 400;
            font-size: 10px;
            line-height: 16px;
            letter-spacing: -0.01px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 2; //显示的行
          }
        }

        .item-right {
          width: 55px;
          height: 53px;
          cursor: pointer;

          .photo {
            height: 100%;
            width: 100%;
          }
        }

        .close-wrap {
          position: absolute;
          top: -6px;
          right: -6px;
          border-radius: 50%;
          width: 13px;
          height: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          background-color: #ff5e6a;

          .close-icon {
            color: white;
          }
        }
      }
    }

    .applet-wrap {
      display: flex;

      .applet-item {
        width: 250px;
        background: #f9f9f9;
        padding: 9px 9px 9px 11px;
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 4px;
        gap: 10px;

        .item-left {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;

          .img {
            height: 100%;
            width: 100%;
          }
        }

        .item-right {
          width: 200px;

          .title {
            font-weight: 600;
            font-size: 14px;
            letter-spacing: -0.01px;
            color: #666666;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .content {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 1; //显示的行
          }

          .photo {
            height: 100%;
            width: 100%;
          }
        }

        .close-wrap {
          position: absolute;
          top: -6px;
          right: -6px;
          border-radius: 50%;
          width: 13px;
          height: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          background-color: #ff5e6a;

          .close-icon {
            color: white;
          }
        }
      }
    }
  }

  .my-preview-image {
    width: 100px;
    height: 100px;
    display: none;

    /deep/ .el-image__inner {
      visibility: hidden !important;
    }
  }
}
</style>
